module.exports = __webpack_public_path__ + "assets/img/icon.bca1851.png";


//////////////////
// WEBPACK FOOTER
// ./client/assets/icon.png
// module id = 100
// module chunks = 11